import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

export type TableCustomSortIconType = 'string' | 'number';
export type AriaSortAttributeType = 'none' | 'ascending' | 'descending';

@Component({
    selector: 'fi-wrapper-table-custom-sort-icon',
    template: `
        <mat-icon class="far" [ngClass]="getMatIconClasses()" />
        <span class="fi-wrapper-table-header-label" [title]="headerLabel | fiAppText">{{
            headerLabel | fiAppText
        }}</span>
    `,
    styleUrls: ['./fi-wrapper-table-custom-sort-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-wrapper-table-custom-sort-icon' },
    standalone: false,
})
export class FiWrapperTableCustomSortIconComponent {
    @Input() ariaSortAttribute: AriaSortAttributeType;
    @Input() sortIconType: TableCustomSortIconType;
    @Input() headerLabel: string;

    getMatIconClasses(): { [key: string]: boolean } {
        return {
            'fa-arrow-down-arrow-up': this.ariaSortAttribute === 'none',
            BrandedColor: this.ariaSortAttribute !== 'none',
            'fa-arrow-down-a-z': this.ariaSortAttribute === 'ascending' && this.sortIconType === 'string',
            'fa-arrow-up-z-a': this.ariaSortAttribute === 'descending' && this.sortIconType === 'string',
            'fa-arrow-down-1-9': this.ariaSortAttribute === 'ascending' && this.sortIconType === 'number',
            'fa-arrow-up-9-1': this.ariaSortAttribute === 'descending' && this.sortIconType === 'number',
        };
    }
}
